import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { procurementApi, type ProcurementDashboard } from '../../api/procurement';

const NAV = [
  { to: '/procurement/planning', label: 'Planning & MRP' },
  { to: '/procurement/requisitions', label: 'Requisitions' },
  { to: '/procurement/rfq', label: 'RFQ manager' },
  { to: '/procurement/purchase-orders', label: 'Purchase orders' },
  { to: '/procurement/grn', label: 'Goods receipt' },
  { to: '/procurement/analytics', label: 'Analytics' },
];

export function ProcurementHubPage() {
  const [dashboard, setDashboard] = useState<ProcurementDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void procurementApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Requisitions', value: dashboard.total_requisitions },
        { label: 'Open POs', value: dashboard.open_pos },
        { label: 'Open RFQs', value: dashboard.open_rfqs },
        { label: 'Pending approvals', value: dashboard.pending_approvals },
        { label: 'Budget consumed', value: `₹${dashboard.budget_consumed.toFixed(0)}` },
        { label: 'Procurement health', value: `${(dashboard.procurement_health * 100).toFixed(0)}%` },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Procurement & Sourcing</h1>
      <p className="mt-1 text-sm text-slate-600">MRP, requisitions, RFQ, purchase orders, goods receipt and analytics.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
